export const REPENDING = "REPENDING"
export const REJECT = "REJECT"
export const PENDING =  "PENDING"
export const ACCEPT =  "ACCEPT"
export const NOTREGISTER = "NOTREGISTER"